import { VStack, HStack } from "@chakra-ui/layout";
import { FormControl, FormLabel } from "@chakra-ui/react";
import { UseFormRegister, FieldErrors, FieldValues } from "react-hook-form";
import { ChangeEvent } from "react";

import { CorporationIdentifiersDictionary } from "doxecure-commons/lib/doxecureTypes";
import { Nullable } from "foundation-ts/types";

import { CorporationForm } from "@/components/CorporationForm/CorporationForm";
import { G1Input } from "@components/G1Input";

import { RegisterFormValues } from "./RegisterTypes";

interface AccountStepProps {
    isAloneUser: Nullable<boolean>;
    corporationIdentifiersDict: CorporationIdentifiersDictionary;
    countries: any;
    errors: FieldErrors<RegisterFormValues>;
    register: UseFormRegister<FieldValues>;
    onCorporationChange: (e: any) => void;
    onCountryChange: (e: ChangeEvent<HTMLSelectElement>) => void;
}

export default function AccountStep(props: AccountStepProps) {
    const {
        isAloneUser,
        corporationIdentifiersDict,
        countries,
        errors,
        register,
        onCorporationChange,
        onCountryChange,
    } = props;

    return (
        <form>
            <VStack>
                <HStack width="100%">
                    <FormControl isRequired>
                        <FormLabel fontSize="1.25em">Nom</FormLabel>
                        <G1Input id="lastname" name="lastname" component="connection.form" autoFocus textTransform="uppercase"
                            registerInput={{ ...register("lastname", { required: true, pattern: /^[a-zàâäéèêëïîôöùûüç]+([ '-][a-zàâäéèêëïîôöùûüç]+)*$/i }) }} />
                    </FormControl>
                    <FormControl isRequired>
                        <FormLabel fontSize="1.25em">Prénom</FormLabel>
                        <G1Input id="firstname" name="firstname" component="connection.form" textTransform="capitalize"
                            registerInput={{ ...register("firstname", { required: true, pattern: /^[a-zàâäéèêëïîôöùûüç]+([ '-][a-zàâäéèêëïîôöùûüç]+)*$/i }) }} />
                    </FormControl>
                </HStack>
                <FormControl isRequired>
                    <FormLabel fontSize="1.25em">Adresse mail</FormLabel>
                    <G1Input id="email" name="email" type="email" component="connection.form" placeholder="test@test.com" textTransform="lowercase"
                        registerInput={{ ...register("email", { required: true, pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i }) }} />
                </FormControl>
                <CorporationForm
                    label={isAloneUser ? "Entreprise" : "Organisation"}
                    component="connection.form"
                    required
                    showUniqueId
                    countries={countries}
                    corporationIdentifiersDict={corporationIdentifiersDict}
                    errors={errors}
                    register={register}
                    onChange={onCorporationChange}
                    onCountryChange={onCountryChange}
                />
            </VStack>
        </form>
    );
}